import { Modal } from 'react-bootstrap';
import { Button } from '@myome/ui';

import { MYOME_SUPPORT_EMAIL } from '@constants/constants';

interface NotGuardianModalProps {
  firstName: string;
  onClose: () => void;
  show: boolean;
}

export function NotGuardianModal({ firstName, onClose, show }: NotGuardianModalProps) {
  const name = firstName.trim() || 'the patient';
  const nextSteps = [
    `Forward the invitation email to ${name}'s parent or legal guardian.`,
    'Or have them open the email and restart on their own device.',
    `Questions? ${MYOME_SUPPORT_EMAIL}`,
  ];

  return (
    <Modal show={show} onHide={onClose} centered className='order-check-eligibility__not-guardian-modal'>
      <Modal.Header closeButton>
        <div className='order-check-eligibility__not-guardian-modal-header'>
          <span className='order-check-eligibility__not-guardian-badge'>Cannot continue without a guardian</span>
          <Modal.Title>A legal guardian needs to finish this</Modal.Title>
        </div>
      </Modal.Header>
      <Modal.Body>
        <p>
          {`Because ${name} is under 18, only a parent or legal guardian can review the consent and complete the order. Nothing you've entered has been saved.`}
        </p>
        <div className='order-check-eligibility__not-guardian-next-steps'>
          <div className='order-check-eligibility__not-guardian-next-steps-header'>What to do next</div>
          <ul>
            {nextSteps.map(step => (
              <li key={step}>{step}</li>
            ))}
          </ul>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button type='button' variant='secondary' onClick={onClose} ariaLabel='Go back to form'>
          Go back to form
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
